import React, { useRef } from 'react';
import styles from './UploadFile.module.scss';
import { Icon, Upload } from 'antd';
import { ReactComponent as AddFilesFromDocumentIcon } from '../../../../resource/AddFilesFromDocumentIcon.svg';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';

const UploadFile = ({ value = [], onChange, isLoading, handleFilesChange }) => {
  const { mode } = useSelector(documentDrawerSelector);

  const isProcessingRef = useRef(false);

  const handleChange = ({ fileList }) => {
    if (isProcessingRef.current) {
      return;
    }

    const newFiles = fileList.filter(
      (f) =>
        !value.some(
          (vf) => vf.uid === f.uid || (vf.name === f.name && vf.size === f.size)
        )
    );

    if (newFiles.length === 0) {
      return;
    }

    isProcessingRef.current = true;

    if (mode === 'edit') {
      onChange(newFiles);
    } else {
      handleFilesChange([...value, ...newFiles]);
      onChange([...value, ...newFiles]);
    }

    setTimeout(() => {
      isProcessingRef.current = false;
    }, 100);
  };

  return (
    <Upload.Dragger
      className={styles.customDragger}
      fileList={value}
      beforeUpload={() => false}
      onChange={handleChange}
      showUploadList={false}
      multiple
    >
      <p>
        {isLoading ? (
          <Icon
            type="loading"
            style={{ margin: 'auto', color: '#0995ED', fontSize: 20 }}
          />
        ) : (
          <AddFilesFromDocumentIcon />
        )}
      </p>
      <p className={styles.title}>Выберите или перетащите документ</p>
      <p className={styles.description}>Любой формат файла, не более 15 МБ</p>
    </Upload.Dragger>
  );
};

export default UploadFile;
